import React from 'react';

const Header = () => {
  return (
    <div className="about-me">
      <h2 className="my-profession">
        Fullstack Game Developer // DevOps
      </h2>

      <h1 className="my-name text text-EN">Mykyta Uginchus</h1>
      <h1 className="my-name text text-UA">Микита Угінчус</h1>

      <p className="my-description text text-EN">
        Professionally structured with a passion for technology, I am adept
        at navigating complex technical landscapes and thrive on learning
        and implementing the latest advancements. With a keen eye for detail
        and a commitment to excellence, I excel in guiding companies towards
        integrating innovative solutions into their projects, optimizing
        processes, and enhancing overall efficiency. I am driven by the
        challenge of staying ahead of the curve in a rapidly evolving tech
        environment, leveraging my expertise to contribute meaningfully to
        the success.
      </p>
      <p className="my-description text text-EN">10+ years in IT.</p>
      <p className="my-description text text-UA">
        Професіонал в організації і структуруванні, захоплений технологіями,
        я завжди відкритий для нового знання та готовий допомагати компаніям
        інтегрувати нові рішення у свої проекти. Маю великий досвід у роботі
        з технічними системами та вмію швидко орієнтуватися у складних
        технічних завданнях. Моє прагнення до відмінності та уважність до
        деталей дозволяють ефективно оптимізувати процеси та покращувати
        результативність роботи. Я завжди готовий приймати виклик та
        використовувати свої знання для досягнення успіху.
      </p>
      <p className="my-description text text-UA">
        Більше 10 років досвіду роботи в IT.
      </p>
    </div>
  );
};

export default Header;
